import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  FetchMirrorAuditListParams,
  MirrorAuditListPageResult
} from 'src/api_v2/mirror-audit/types';
import mirrorAuditApi from 'src/api_v2/mirror-audit/mirror-audit-list-api';
import {
  selectPage,
  selectPageSize,
  selectSearch,
  selectSort
} from './selector';
import { actions } from './slice';

function* fetchMirrorAuditList() {
  try {
    const page = yield select(selectPage);
    const pageSize = yield select(selectPageSize);
    const search = yield select(selectSearch);
    const sort = yield select(selectSort);
    const queryParams = new FetchMirrorAuditListParams(page, pageSize, search, sort);
    const result: MirrorAuditListPageResult = yield call(
      mirrorAuditApi.fetchMirrorAuditList,
      queryParams
    );

    yield put(actions.mirrorAuditListFetched(result));
  } catch (err) {
    console.log(err);
    yield put(actions.mirrorAuditListFetchedError());
  }
}

function* fetchTotalMirrorAuditList() {
  try {
    const search = yield select(selectSearch);
    const sort = yield select(selectSort);

    const queryParams = new FetchMirrorAuditListParams(
      1,
      Number.MAX_SAFE_INTEGER,
      search,
      sort
    );
    const result: MirrorAuditListPageResult = yield call(
      mirrorAuditApi.fetchMirrorAuditList,
      queryParams
    );

    yield put(actions.mirrorAuditListFetched(result));
  } catch (err) {
    console.log(err);
    yield put(actions.mirrorAuditListFetchedError());
  }
}

function* exportFile() {
  const page = yield select(selectPage);
  const pageSize = yield select(selectPageSize);
  const search = yield select(selectSearch);
  const sort = yield select(selectSort);
  const queryParams = new FetchMirrorAuditListParams(page, pageSize, search, sort);

  try {
    yield call(mirrorAuditApi.exportFile,queryParams)

    yield put(actions.unscreenHistoryExported())
  } catch (err) {
    console.log(err);
    yield put(actions.unscreenHistoryExportedFail());
  }
}

export default function* watchMirrorAuditListSaga() {
  yield takeLatest(actions.fetchMirrorAuditList.type, fetchMirrorAuditList);
  yield takeEvery(actions.fetchTotalMirrorAuditList.type, fetchTotalMirrorAuditList);
  yield takeEvery(actions.exportFile.type, exportFile);
}
